import { useMutation } from "@tanstack/react-query"

import { supabase } from "@/lib/supabase"
import { getSupabaseFunctionErrorMessage } from "@/utils/supabaseFunctionUtils"

export type SendAuthLinkPayload = {
  email: string
  linkType?: "invite" | "recovery"
}

export const useSendAuthLink = () => {
  return useMutation({
    mutationFn: async ({ email, linkType }: SendAuthLinkPayload) => {
      const { data, error } = await supabase.functions.invoke("send-auth-link", {
        body: { email, linkType },
      })

      if (error) {
        throw new Error(await getSupabaseFunctionErrorMessage(error))
      }

      return data as { success: boolean; message?: string }
    },
  })
}
